/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, Popover, Typography } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import qs from "query-string";
import API from "../../Utils/Interceptor/ApiMiddleware";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";
import CountInfo from "../../components/Composables/TilesCountInfo";
import DynamicDataGrid from "../../components/Composables/DynamicDataGrid";
import formatters from "../../components/Composables/DataGridFormatters";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DynamicForm from "../../components/Composables/DynamicForm";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { debounce } from "lodash";

// Logs Component
export default function Logs() {
  const [loading, setLoading] = useState({
    count: false,
    grid: false,
  });
  const location = useLocation();
  const debounceTimeout = useRef(null);
  const navigate = useNavigate();
  const latestInputValue = useRef("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [logsData, setLogsData] = useState({
    countData: [],
    listData: {},
    paginationModel: {
      pageSize: 25,
      page: 0,
    },
  });

  const [formConfigurations, setFormConfigurations] = useState([
    {
      label: "Portal Name",
      type: "autocomplete-multiple",
      name: "portalName",
      options: [
        { value: 1, label: "Jobeze Portal" },
        { value: 2, label: "Employer Portal" },
        { value: 3, label: "Site-Admin Portal" },
      ],
      text: "Portal Name",
    },
    {
      label: "Log Status",
      type: "autocomplete-multiple",
      name: "logStatus",
      options: [
        { value: "Success", label: "Success" },
        { value: "Error", label: "Error" },
      ],
      text: "Log Status",
    },
    {
      label: "Start Date",
      type: "date",
      name: "startDate",
      options: [],
      text: "Start Date",
    },
    {
      label: "End Date",
      type: "date",
      name: "endDate",
      options: [],
      text: "End Date",
    },
    {
      label: "User Name",
      type: "autocomplete-multiple",
      name: "userName",
      options: [],
      text: "User Name",
    },
  ]);
  let temp = JSON.parse(localStorage.getItem("tempFormState"));
  if(!temp){
    temp = {
    portalName: null,
    logStatus: null,
    startDate: null,
    endDate: null,
    userName: null,
  }
  }
  const [formState, setFormState] = useState(
  //   {
  //   portalName: null,
  //   logStatus: null,
  //   startDate: null,
  //   endDate: null,
  //   userName: null,
  // }
  temp
);

  const [appliedFilters, setAppliedFilters] = useState(
  //   {
  //   portalName: null,
  //   logStatus: null,
  //   startDate: null,
  //   endDate: null,
  //   userName: null,
  // }
  temp
);

  const [tempFormState, setTempFormState] = useState(formState);

  const handleChange = (key, value, inputValue = null) => {
    setTempFormState((prev) => ({
      ...prev,
      [key]: value,
      [`${key}Input`]: inputValue !== null ? inputValue : prev[`${key}Input`],
    }));

    if (inputValue !== null) {
      latestInputValue.current = inputValue;
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        fetchLogsFilterData({ [`${key}Search`]: latestInputValue.current });
      }, 1000);
    }
  };

  const fetchLogsFilterData = async (filterParams) => {
    try {
      const response = await API.get("log/get-logs-filter-details", {
        params: filterParams,
      });

      if (response) {
        const apiData = response.data.data;

        setFormConfigurations((prevConfig) =>
          prevConfig.map((config) => {
            if (config.name === "userName" && apiData.length > 0) {
              const newOptions = apiData
                .filter((item) => item.name)
                .map((item) => ({ value: item.name, label: item.name }));

              return { ...config, options: newOptions };
            }
            return config;
          })
        );
      }
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setTempFormState(formState);
  };

  const fetchLogsData = async () => {
    setLoading((prev) => ({
      ...prev,
      count: true,
    }));
    try {
      const response = await API.post("tiles/get-count", {
        tile_type: "log_count",
      });
      const apiData = response.data.data;

      setLogsData((prevState) => ({
        ...prevState,
        countData: apiData,
      }));
    } catch (error) {
      console.error("Error fetching logs data:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        count: false,
      }));
    }
  };

  useEffect(() => {
    const queryParams = qs.parse(location.search);
    const {
      page = 1,
      portalName,
      logStatus,
      startDate,
      endDate,
      userName,
    } = queryParams;

    const filtersFromQuery = {
      portalName: portalName
        ? Array.isArray(portalName)
          ? portalName.map(Number)
          : [Number(portalName)]
        : null,
      logStatus: logStatus
        ? Array.isArray(logStatus)
          ? logStatus
          : [logStatus]
        : null,
      startDate: startDate
        ? dayjs(Array.isArray(startDate) ? startDate[0] : startDate)
        : null,
      endDate: endDate
        ? dayjs(Array.isArray(endDate) ? endDate[0] : endDate)
        : null,
      userName: userName
        ? Array.isArray(userName)
          ? userName
          : [userName]
        : null,
    };

    setFormState(filtersFromQuery);
    setAppliedFilters(filtersFromQuery);

    setLogsData((prev) => ({
      ...prev,
      paginationModel: {
        ...prev.paginationModel,
        page: parseInt(page) - 1,
      },
    }));
  }, [location.search]);

  useEffect(() => {
    if (anchorEl) {
      const fieldsToFetch = formConfigurations
        .filter(
          (field) =>
            field.type === "autocomplete-multiple" &&
            !(field.options && field.options.length > 0)
        )
        .map((field) => field.name);

      const payload = {};

      fieldsToFetch.forEach((field) => {
        if (formState[field] !== null && formState[field] !== undefined) {
          payload[`${field}Search`] = "";
        }
      });

      if (Object.keys(payload).length > 0) {
        fetchLogsFilterData(payload);
      }
    }
  }, [anchorEl, formConfigurations]);

  const handleResetFilters = async () => {
    const resetFilters = {
      portalName: null,
      logStatus: null,
      startDate: null,
      endDate: null,
      userName: null,
    };

    setFormState(resetFilters);
    setTempFormState(resetFilters);

    setLogsData((prevState) => ({
      ...prevState,
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    }));

    const query = qs.stringify(
      {
        ...resetFilters,
        page: 1,
      },
      { skipNull: true, skipEmptyString: true }
    );

    navigate(`/logs?${query}`);
    handleClose();
  };

  const handleApplyFilters = () => {
    const query = qs.stringify(
      {
        ...tempFormState,
        page: 1,
      },
      { skipNull: true, skipEmptyString: true }
    );
    setFormState(tempFormState);
    setAppliedFilters(tempFormState);
    localStorage.setItem("tempFormState", JSON.stringify(tempFormState))
    setLogsData((prev) => ({
      ...prev,
      paginationModel: {
        ...prev.paginationModel,
        page: 0,
      },
    }));

    navigate(`/logs?${query}`);

    handleClose();
  };

  const debouncedFetchLogsFilterData = debounce(fetchLogsFilterData, 500);

  const fetchLogsGridData = useCallback(async () => {
    const formatDate = (date) =>
      date ? dayjs(date).format("YYYY-MM-DD") : null;

    const payload = {
      portal_id: appliedFilters.portalName,
      log_status: appliedFilters.logStatus,
      start_date: formatDate(appliedFilters.startDate),
      end_date: formatDate(appliedFilters.endDate),
      user_name: appliedFilters.userName,
      pageSize: logsData.paginationModel.pageSize,
      page: logsData.paginationModel.page + 1,
    };

    setLoading((prev) => ({
      ...prev,
      grid: true,
    }));

    try {
      const response = await API.post("log/get-logs", payload);
      const apiData = response?.data?.data || { logDetails: [], totalLogs: 0 };

      setLogsData((prevState) => ({
        ...prevState,
        listData: apiData,
      }));
    } catch (error) {
      console.error("Error fetching logs grid data:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        grid: false,
      }));
    }
  }, [
    appliedFilters.portalName,
    appliedFilters.logStatus,
    appliedFilters.startDate,
    appliedFilters.endDate,
    appliedFilters.userName,
    logsData.paginationModel.page,
    logsData.paginationModel.pageSize,
  ]);

  // useEffect(() => {
  //   console.log("logsData", logsData);
  // }, [logsData]);

  useEffect(() => {
    fetchLogsData();
  }, []);
  useEffect(() => {
    fetchLogsGridData();
  }, [fetchLogsGridData]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        boxSizing: "border-box",
        borderRadius: "24px 0 0 0",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "16px",
          marginBottom: "16px",
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          Logs
        </Typography>

        {loading.count ? (
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              flex: 1,
              textAlign: "center",
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100px",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : logsData.countData.length > 0 ? (
          <CountInfo sections={logsData.countData} showHeader={false} />
        ) : (
          <CountInfo sections={[]} showHeader={false} />
        )}
      </Box>
      <Box
        sx={{
          borderRadius: "12px",
          padding: "16px",
          backgroundColor: "white",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
            Recent Logs
          </Typography>

          <Box>
            <Button
              sx={{
                backgroundColor: "#2196F3",
                padding: "6px 10px",
                color: "white",
                display: "flex",
                alignItems: "center",
                borderRadius: "5px",
              }}
              onClick={(e) => handleOpen(e)}
            >
              <FilterAltOutlinedIcon
                sx={{ fontSize: 20, marginRight: "8px" }}
              />
              <Typography sx={{ fontSize: "14px" }}>FILTER</Typography>
            </Button>
          </Box>
        </Box>
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <DynamicDataGrid
            rows={logsData.listData.logDetails || []}
            showCheckbox={false}
            formatters={formatters}
            totalRows={logsData.listData.totalLogs || 0}
            paginationModel={logsData.paginationModel}
            buttonName="log"
            onPaginationModelChange={(paginationModel) => {
              setLogsData((prev) => ({
                ...prev,
                paginationModel: paginationModel,
              }));
              navigate(
                `/logs?${qs.stringify(
                  {
                    ...appliedFilters,
                    page: paginationModel.page + 1,
                  },
                  { skipNull: true, skipEmptyString: true }
                )}`
              );
            }}
            loading={loading.grid}
          />
        </Box>
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ p: 2, width: 410 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Logs Filters
          </Typography>
          <Divider sx={{ my: 1 }} />
          {formConfigurations ? (
            <DynamicForm
              formData={formConfigurations}
              formState={tempFormState}
              handleChange={handleChange}
              debouncedFilterData={debouncedFetchLogsFilterData}
              filterData={fetchLogsFilterData}
            />
          ) : (
            <LoadingSpinner />
          )}

          <Box
            sx={{ display: "flex", mt: 2, justifyContent: "flex-end", gap: 2 }}
          >
            <Button color="primary" onClick={handleResetFilters}>
              Reset
            </Button>
            <Button variant="contained" onClick={handleApplyFilters}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
}
